export function getSelectedSound(state) {
  return state.soundAlerts.selectedSound;
}

export function getEnabled(state) {
  return state.soundAlerts.enabled;
}

export function getRepeat(state) {
  return state.soundAlerts.repeat;
}

export function getDelay(state) {
  return state.soundAlerts.delay;
}
